import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import history from './history';
import Main from './Main';
import AdminApp from './admin-components/AdminApp';

const App = () => (
  <Switch>
    <Route exact path="/" component={Main}/>
    <Route path="/admin" component={AdminApp}/>
    
    <Redirect to="" />
  </Switch>
)

ReactDOM.render((
	  <BrowserRouter history={history}>
	    <App />
	  </BrowserRouter>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js